import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import Footer from "../pallet/Footer";

export default function Step0({ onNext }) {
  const handleNext = () => {
    onNext();
  };

  return (
    <>
      <DialogContent>
        <Box minHeight={300} display="flex" alignItems="center">
          <Box width={320} margin="0 auto">
            <Box
              my={1}
              mb={5}
              alt="Warehouse worker moving inventory"
              component="img"
              borderRadius={2}
              width="100%"
              maxWidth={360}
              src="/pallet-count-assistant.png"
            />
            <Typography align="center" sx={{ mb: 4, fontWeight: 500 }}>
              I'll help you create a new receiving report for the inventory you captured onsite.
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <Footer step={0}>
        <Box />
        <Button variant="contained" color="primary" onClick={handleNext} sx={{ minWidth: 100 }}>
          Start
        </Button>
      </Footer>
    </>
  );
}
